'use client';

import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React from 'react';

import { ContractDocumentsRow } from '../../../types';

interface AddContractDocumentProps {
	showModal: (editRow?: ContractDocumentsRow) => void;
}

export const AddContractDocumentButton = ({ showModal }: AddContractDocumentProps) => (
	<Button
		size='small'
		variant='outlined'
		startIcon={<AddIcon />}
		onClick={() => showModal()}
		data-cy='add-document-datagrid-button'
	>
		Add Document
	</Button>
);
